import gql from 'graphql-tag'

export const QUERY_UNITS = gql`
  query Units {
    units: allUnits {
      _id
      id_erp
      name
      cnpj
      address
      mobile
      pdv_token
      contact
      ecommerce_v2_active
      active
      retailer_flag_id
      unit_group {
        _id
        name
      }
      tags {
        name
        color
      }
      location {
        type
        coordinates
      }
      address_components {
        postal_code
        street
        neighborhood
        number
        complement
        city
        city_name
        federative_unit
      }
      office_hours {
        monday {
          start
          finish
        }
        tuesday {
          start
          finish
        }
        wednesday {
          start
          finish
        }
        thursday {
          start
          finish
        }
        friday {
          start
          finish
        }
        saturday {
          start
          finish
        }
        sunday {
          start
          finish
        }
        holidays {
          start
          finish
        }
      }
      ecommerce_partner {
        partner_type
        partner_unit_id
      }
    }
  }
`
